module.exports = __webpack_public_path__ + "af.14c45ecc.svg";